import {
	PropsWithChildren,
	ReactElement,
	ReactNode
} from "react";
import { setTrackingId } from "client/Misc/utils";
import { flattenChildren, getReactNodeKey } from "client/Misc/reactUtils";
import styles from "./UserLicenseList.module.less";

export type UserLicenseListProps = {
	trackingId: string;
};

export const UserLicenseList = (props: PropsWithChildren<UserLicenseListProps>): ReactElement => {
	const {
		trackingId,
		children
	} = props;

	const childrenArray: ReactNode[] = flattenChildren(children);

	return (
		<ul
			{...setTrackingId(trackingId)}
			className={styles.root}
		>
			{childrenArray.map(
				(c, i) => (
					<li key={getReactNodeKey(c, i)}>
						{c}
					</li>
				)
			)}
		</ul>
	);
};
UserLicenseList.displayName = "UserLicenseList";